import { buildDocumentLinkPdfUrl } from '@ztechapps/common.utils'
import { useCreateOrderDocumentLink } from '../useCreateOrderDocumentLink'

export type UseOrderPdfUrlResult = () => Promise<string>

/** Returns a function that creates a link for the order and resolves to its public PDF address. */
export const useOrderPdfUrl = ({ rootUrl, orderId }: { rootUrl: string; orderId?: string }): UseOrderPdfUrlResult => {
  const { mint } = useCreateOrderDocumentLink()

  return async (): Promise<string> => {
    const { token } = await mint(orderId)
    return buildDocumentLinkPdfUrl({ rootUrl, token })
  }
}
